import { parseFromStripe } from "./parseFromStripe";

const today = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 0,
    amount_paid: 0,
    amount_remaining: 0,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694576637,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: -34805,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_13c46bGSTSE9ZxBo4ce708e2",
                object: "line_item",
                amount: -57475,
                amount_excluding_tax: -57475,
                currency: "myr",
                description: "Unused time on Subscription (Yearly) after 10 Sep 2023",
                discount_amounts: [],
                discountable: false,
                discounts: [],
                invoice_item: "ii_1NpjzdGSTSE9ZxBoRI6ZSClw",
                livemode: false,
                metadata: {},
                period: {
                    end: 1725166698,
                    start: 1694361600,
                },
                plan: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 59000,
                    amount_decimal: "59000",
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    interval: "year",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LmYneGSTSE9ZxBoV5IU4OIR",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1664265954,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Growth Yearly",
                    product: "prod_MGzJfZXz64Daac",
                    recurring: {
                        aggregate_usage: null,
                        interval: "year",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 59000,
                    unit_amount_decimal: "59000",
                },
                proration: true,
                proration_details: {
                    credited_items: {
                        invoice: "in_1NlPR0GSTSE9ZxBoLzDJ8KZb",
                        invoice_line_items: [
                            "il_1NlPR0GSTSE9ZxBoVQoslLpL",
                        ],
                    },
                },
                quantity: 1,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OYWTBa81lr7zPg",
                tax_amounts: [],
                tax_rates: [],
                type: "invoiceitem",
                unit_amount_excluding_tax: "-57475",
            },
            {
                id: "il_tmp_1396bcGSTSE9ZxBoa302e6af",
                object: "line_item",
                amount: 1490,
                amount_excluding_tax: 1490,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168637,
                    start: 1694576637,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczzhMlIEfB9v1",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_19b535GSTSE9ZxBo526f1424",
                object: "line_item",
                amount: 1380,
                amount_excluding_tax: 1380,
                currency: "myr",
                description: "2 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168637,
                    start: 1694576637,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 2,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczzJg4dsfgt1A",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_1f886dGSTSE9ZxBodf865fbb",
                object: "line_item",
                amount: 19800,
                amount_excluding_tax: 19800,
                currency: "myr",
                description: "2 × Subscription (Monthly) (at RM99.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168637,
                    start: 1694576637,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 2,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_OczzVCwc2MbFBB",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "9900",
            },
        ],
        has_more: false,
        total_count: 4,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NlPR0GSTSE9ZxBoRGYf3SSZ&subscription_proration_date=1694361600&subscription_proration_behavior=always_invoice&subscription_items%5B3%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B3%5D%5Bquantity%5D=2&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OYWTBa81lr7zPg&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bquantity%5D=2&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694576637,
    period_start: 1694576637,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694361600,
    subtotal: -34805,
    subtotal_excluding_tax: -34805,
    tax: null,
    test_clock: null,
    total: -34805,
    total_discount_amounts: [],
    total_excluding_tax: -34805,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const nextNoProration = {
    object: "invoice",
    account_country: "MY",
    account_name: "Bukku-yichangteh",
    account_tax_ids: null,
    amount_due: 22670,
    amount_paid: 0,
    amount_remaining: 22670,
    amount_shipping: 0,
    application: null,
    application_fee_amount: null,
    attempt_count: 0,
    attempted: false,
    automatic_tax: {
        enabled: false,
        status: null,
    },
    billing_reason: "upcoming",
    charge: null,
    collection_method: "charge_automatically",
    created: 1694576669,
    currency: "myr",
    custom_fields: null,
    customer: "cus_OXR6bokjAgeGq1",
    customer_address: null,
    customer_email: "gotil69123@poverts.com",
    customer_name: "Test Proration ENG-3319",
    customer_phone: null,
    customer_shipping: {
        address: {
            city: "",
            country: "",
            line1: "",
            line2: "",
            postal_code: "",
            state: "",
        },
        name: "Test Proration ENG-3319",
        phone: "",
    },
    customer_tax_exempt: "none",
    customer_tax_ids: [],
    default_payment_method: null,
    default_source: null,
    default_tax_rates: [],
    description: null,
    discount: null,
    discounts: [],
    due_date: null,
    effective_at: null,
    ending_balance: 0,
    footer: null,
    from_invoice: null,
    last_finalization_error: null,
    latest_revision: null,
    lines: {
        object: "list",
        data: [
            {
                id: "il_tmp_142b5cGSTSE9ZxBo55006d02",
                object: "line_item",
                amount: 1490,
                amount_excluding_tax: 1490,
                currency: "myr",
                description: "1 × WhatsApp File Top Up (at RM14.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168669,
                    start: 1694576669,
                },
                plan: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 1490,
                    amount_decimal: "1490",
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlIxGSTSE9ZxBoY5RZTJkp",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692675055,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkofqzgSrcX9Q",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 1490,
                    unit_amount_decimal: "1490",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 1,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_Od00vuBUdvnrtG",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "1490",
            },
            {
                id: "il_tmp_10ba87GSTSE9ZxBo93e65131",
                object: "line_item",
                amount: 1380,
                amount_excluding_tax: 1380,
                currency: "myr",
                description: "2 × Email Top Up (at RM6.90 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168669,
                    start: 1694576669,
                },
                plan: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 690,
                    amount_decimal: "690",
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1NhlI2GSTSE9ZxBo2zfnO7Rw",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1692674998,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: null,
                    product: "prod_OUkn9aRRQeOM4E",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 690,
                    unit_amount_decimal: "690",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 2,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_Od002GqYVnWckd",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "690",
            },
            {
                id: "il_tmp_103af0GSTSE9ZxBo844d6b0b",
                object: "line_item",
                amount: 19800,
                amount_excluding_tax: 19800,
                currency: "myr",
                description: "2 × Subscription (Monthly) (at RM99.00 / month)",
                discount_amounts: [],
                discountable: true,
                discounts: [],
                livemode: false,
                metadata: {},
                period: {
                    end: 1697168669,
                    start: 1694576669,
                },
                plan: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "plan",
                    active: true,
                    aggregate_usage: null,
                    amount: 9900,
                    amount_decimal: "9900",
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    interval: "month",
                    interval_count: 1,
                    livemode: false,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    tiers_mode: null,
                    transform_usage: null,
                    trial_period_days: null,
                    usage_type: "licensed",
                },
                price: {
                    id: "price_1LYQytGSTSE9ZxBop8hNIMcD",
                    object: "price",
                    active: true,
                    billing_scheme: "per_unit",
                    created: 1660899307,
                    currency: "myr",
                    custom_unit_amount: null,
                    livemode: false,
                    lookup_key: null,
                    metadata: {},
                    nickname: "Premium",
                    product: "prod_MGywDXexxUs3Xw",
                    recurring: {
                        aggregate_usage: null,
                        interval: "month",
                        interval_count: 1,
                        trial_period_days: null,
                        usage_type: "licensed",
                    },
                    tax_behavior: "unspecified",
                    tiers_mode: null,
                    transform_quantity: null,
                    type: "recurring",
                    unit_amount: 9900,
                    unit_amount_decimal: "9900",
                },
                proration: false,
                proration_details: {
                    credited_items: null,
                },
                quantity: 2,
                subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
                subscription_item: "si_Od00WSOMk01Uet",
                tax_amounts: [],
                tax_rates: [],
                type: "subscription",
                unit_amount_excluding_tax: "9900",
            },
        ],
        has_more: false,
        total_count: 3,
        url: "/v1/invoices/upcoming/lines?subscription=sub_1NlPR0GSTSE9ZxBoRGYf3SSZ&subscription_proration_behavior=none&subscription_items%5B0%5D%5Bquantity%5D=1&subscription_items%5B0%5D%5Bid%5D=si_OYWTBa81lr7zPg&subscription_items%5B0%5D%5Bdeleted%5D=true&subscription_items%5B3%5D%5Bprice%5D=price_1LYQytGSTSE9ZxBop8hNIMcD&subscription_items%5B3%5D%5Bquantity%5D=2&subscription_items%5B3%5D%5Bdeleted%5D=false&subscription_items%5B1%5D%5Bprice%5D=price_1NhlIxGSTSE9ZxBoY5RZTJkp&subscription_items%5B1%5D%5Bquantity%5D=1&subscription_items%5B1%5D%5Bdeleted%5D=false&subscription_items%5B2%5D%5Bprice%5D=price_1NhlI2GSTSE9ZxBo2zfnO7Rw&subscription_items%5B2%5D%5Bquantity%5D=2&subscription_items%5B2%5D%5Bdeleted%5D=false&customer=cus_OXR6bokjAgeGq1",
    },
    livemode: false,
    metadata: {},
    next_payment_attempt: null,
    number: null,
    on_behalf_of: null,
    paid: false,
    paid_out_of_band: false,
    payment_intent: null,
    payment_settings: {
        default_mandate: null,
        payment_method_options: null,
        payment_method_types: null,
    },
    period_end: 1694576669,
    period_start: 1694576669,
    post_payment_credit_notes_amount: 0,
    pre_payment_credit_notes_amount: 0,
    quote: null,
    receipt_number: null,
    rendering_options: null,
    shipping_cost: null,
    shipping_details: null,
    starting_balance: 0,
    statement_descriptor: null,
    status: "draft",
    status_transitions: {
        finalized_at: null,
        marked_uncollectible_at: null,
        paid_at: null,
        voided_at: null,
    },
    subscription: "sub_1NlPR0GSTSE9ZxBoRGYf3SSZ",
    subscription_details: {
        metadata: {},
    },
    subscription_proration_date: 1694576669,
    subtotal: 22670,
    subtotal_excluding_tax: 22670,
    tax: null,
    test_clock: null,
    total: 22670,
    total_discount_amounts: [],
    total_excluding_tax: 22670,
    total_tax_amounts: [],
    transfer_data: null,
    webhooks_delivered_at: null,
};

const DiffCycleDowngrade = parseFromStripe(today);
const DiffCycleNoProration = parseFromStripe(nextNoProration);

export const DiffCycleYearToMonthDowngradeExpected = {
    today: DiffCycleDowngrade,
    next: DiffCycleNoProration,
};
